module.exports = __webpack_public_path__ + "../resources/images/SkyCode_20-7d318ae3eb5ec504bf482a475ea780a3.svg";